import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import ComboBox from 'Components/ComboBox'
import CustomButton from 'Components/CustomButton/CustomButton'
import { Input } from 'Components/Input'
import { makeGetRequest, makePostRequest, makePutRequest } from 'utils/api'
import { currentDate } from 'utils/helpers'
import urls from 'utils/urls'
import { UTILISATION } from 'utils/constants'
import { useParams, useNavigate } from 'react-router-dom'

export default function DoneOperationForm({ setDoneF, setOperations, operations, oid }) {
  const [open, setOpen] = useState(true)
  const { id } = useParams()
  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      IdMaintenanceplan: id,
      id: oid,
      RealisationDate: currentDate(),
      RealCost: '',
      Vendors: '',
      Done: true,
    },
  })

  useEffect(() => {}, [])

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    reset()
    setDoneF(false)
  }

  const onSubmit = async (data) => {
    const response = await makePutRequest(
      urls.crudEntretienRealiserOperations + `${data.id}/`,
      data,
      {},
      true,
    )
    if (response.status === 200) {
      const filteredOperations = operations.results.filter((v) => oid !== v.id)
      setOperations({
        ...operations,
        results: filteredOperations,
        count: operations.count - 1,
      })
      handleClose()
    }
  }
  return (
    <>
      {/* <CustomButton onClick={handleClickOpen}>créer</CustomButton> */}
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ backgroundColor: '#202020' }}>Done Oepration</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="RealisationDate"
              label="Date de réalisation"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="RealCost"
              label="Coût réel"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Vendors"
              label="Fournisseurs"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
